import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { BoxLoader } from './common/box-loader';

export const AccountBalancePageLoader = () => {
  return (
    <div>
      <PageHeaderLoader hasSubheading hideActions />
      <BoxLoader columnsCount={1} width="25%" contentWidth="45%" />
      <br />
      <br />
      <TableLoader hideActions columnsCount={7} />
      <br />
    </div>
  );
};
